/*  THE PLAYBACK TRIM FOR EVERY PREVIEW, so the kit does not shout at you.

    THE PROBLEM, MEASURED. Across the 48 previews on the two long form pages the loudest
    was 15.9 times the quietest, which is 24 dB. Every drum sample peaks at digital full
    scale and the Analog Lab presets sit around a tenth of that, so stepping from a preset
    to a drum was an eight fold jump in level. Nobody reads that as "the drums are hot",
    they read it as the site being broken, and they reach for the volume before they reach
    for the next preview.

    HOW LOUD IS MEASURED. Frame the file into 100ms windows, take the RMS of each, and use
    the 90th percentile of those. Not overall RMS: a soundscape with a long quiet opening
    averages out quiet and would then be boosted until its loud half was deafening. The
    90th percentile asks how loud the file is when it is actually doing something, which
    is what somebody auditioning it hears.

    THE TARGET is the median of all 48, so the trim moves the outliers rather than the
    whole set, and the kit keeps roughly the level it already had.

    THE CLAMPS ARE 0.30 AND 3.00 AND THEY ARE DELIBERATELY NOT WIDER. Matching perfectly
    means cutting the drums to a quarter and lifting the quietest preset by 3.4, which
    flattens every intentional difference in the kit and lifts the noise floor on the
    quiet material. At these limits the residual spread is 4 dB, down from 24. Four dB is
    the difference between two records mastered by different people, which is the point:
    it should sound like one collection, not like one file.

    NOTHING IS ALLOWED TO CLIP. Every trim is capped at 0.99 divided by the file's true
    peak, so a boost can never push a sample into distortion. That cap is what actually
    limits several of the drum entries rather than the clamp.

    KEYED BY FILENAME WITHOUT THE EXTENSION, the same convention as ev-peaks.js and
    ev-dur.js, because the previews were WAV when they were measured and are AAC now.
    A preview with no entry plays at 1.0, which is exactly what it did before this file
    existed, so an unlisted file is never silent or broken.

    REGENERATE THIS WHEN PREVIEWS CHANGE. A trim computed against a file that has since
    been re-exported is worse than no trim at all.  */

window.EV_GAIN = {
  "CFX_-_ARM_LEG_-_ONESHOT": 0.744,
  "CFX_-_BACK_TO_WORK_-_ONESHOT": 1.358,
  "CFX_-_DAY_JOG_-_ONESHOT": 1.216,
  "CFX_-_DEATH_NOTE_-_BMIN": 0.633,
  "CFX_-_GHOST_OF_OPERA_-_A_MIN": 0.81,
  "CFX_-_GUMMY_WORM_-_ONESHOT": 1.679,
  "CFX_-_POWER_OUTAGE_-_ONESHOT": 0.911,
  "CFX_-_SECRET_OPERATIONS_-_CMIN": 0.459,
  "CFX_-_SLOW_IT_DOWN_HUGHHH_-_CMIN": 0.702,
  "CFX_-_SOLITUDE_AND_FORTITUDE_-_A_MIN": 0.758,
  "CFX_-_VOCAL_ALL_I_WANTED_-_140_BPM_F": 0.893,
  "CFX_-_VOCAL_FREAK_OFF_-_130_BPM_F": 1.549,
  "CFX_-_VOCAL_IN_YOUR_HANDS_-_145_BPM_F": 0.911,
  "CFX_-_WRIZZLE_PLUCKS_-_CMIN": 0.515,
  "ENHANCEMENT_PRESET": 1.369,
  "FALLOUT_PAD__2": 2.305,
  "KEYMAJOR_-_2025_GRANULAR": 1.131,
  "KEYMAJOR_-_4_PERKS_808": 0.359,
  "KEYMAJOR_-_APPLE_PIE_GRANULAR": 2.574,
  "KEYMAJOR_-_AVALANCHE_GRANULAR": 2.658,
  "KEYMAJOR_-_BIZARRE_GRANULAR": 1.025,
  "KEYMAJOR_-_CONTRAST_SNARE": 0.464,
  "KEYMAJOR_-_DIST_ZAY_808": 0.3,
  "KEYMAJOR_-_DYING_LIGHT_3_GRANULAR": 1.571,
  "KEYMAJOR_-_E-DAY_GRANULAR": 1.294,
  "KEYMAJOR_-_ECHO_ECHO_GRANULAR": 2.149,
  "KEYMAJOR_-_FELT_LIKE_YE_-_DRUM_SAMPLE": 0.308,
  "KEYMAJOR_-_FOCUSED_CLAP": 0.621,
  "KEYMAJOR_-_GOAT_PERC": 0.802,
  "KEYMAJOR_-_HEART_BEAT_A_-_DRUM_SAMPLE": 0.3,
  "KEYMAJOR_-_HOT_CHIPS_808": 0.334,
  "KEYMAJOR_-_JUP-8_GRANULAR": 1.479,
  "KEYMAJOR_-_NORTHERN_B_-_DRUM_SAMPLE": 0.302,
  "KEYMAJOR_-_SOUNDSCAPE_10": 1.017,
  "KEYMAJOR_-_SOUNDSCAPE_11": 2.286,
  "KEYMAJOR_-_SOUNDSCAPE_12": 0.991,
  "KEYMAJOR_-_SOUNDSCAPE_18": 0.934,
  "KEYMAJOR_-_SOUNDSCAPE_22": 0.983,
  "KEYMAJOR_-_SOUNDSCAPE_6": 1.826,
  "KEYON_-_CLOUT_CLUB_D_-_DRUM_SAMPLE": 0.3,
  "KEYON_-_CODING_INTRO_D_-_DRUM_SAMPLE": 0.3,
  "KEYON_-_ISLAND_ROLL_A_-_DRUM_SAMPLE": 0.32,
  "LOCUST_AMBIENT_PAD_2": 2.536,
  "MULTI_KEYS_PREVIEW_10": 2.106,
  "OMINOUS_SYNTH_KEY_2": 2.759,
  "PEDAL_GONE_WRONG_SYNTH_KEY_2": 3.0,
  "PEDAL_MAGIC_SYNTH_KEY_2": 1.882,
  "POWERDAY_LOFI_KEY_2": 2.053
};